import {
  AuthClientEvent,
  AuthClientTokens,
} from '@react-keycloak/core/lib/types';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import React, { useEffect, useState } from 'react';
import Loading from './shared/components/loading';
import './shared/i18n';
import { useGetOidcConfigurationQuery } from './shared/services/publicApi';
import { useAppDispatch } from './shared/state/redux-hooks';
import { registerKeycloakToken } from './shared/state/slices/token/tokenSlice';
import { getBaseUrl } from './shared/utils';
import Keycloak from 'keycloak-js';
import { AppRouter } from './routes';

import './assets/css/App.scss';
import 'react-inner-image-zoom/lib/styles.min.css';
import { registerKeycloakConfig } from './shared/state/slices/keycloackConfig/keyCloakConfigSlice';

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const [keycloakInstance, setKeycloakInstance] = useState<Keycloak | null>(
    null,
  );

  const {
    data: oidc,
    isSuccess,
    isLoading,
    isFetching,
  } = useGetOidcConfigurationQuery(undefined, {
    skip: keycloakInstance !== null,
  });

  useEffect(() => {
    if (isSuccess && oidc?.clientId) {
      const newKc = new Keycloak(oidc);
      setKeycloakInstance(newKc);
      dispatch(registerKeycloakConfig(oidc));
    }
  }, [oidc, isSuccess, dispatch]);

  const refreshError = (eventType: AuthClientEvent) => {
    if (eventType === 'onAuthRefreshError' && keycloakInstance) {
      keycloakInstance
        .logout({
          redirectUri: `${getBaseUrl(
            new URL(window.location.href),
          )}/unauthorized?from=${window.location.href}`,
        })
        .then(() => keycloakInstance.clearToken());
    }
  };

  const tokenLogger = async (tokens: AuthClientTokens) => {
    dispatch(registerKeycloakToken(tokens.token));
  };

  if (isLoading || isFetching || !keycloakInstance) {
    return <Loading message="loading.oidc" />;
  }

  return (
    <ReactKeycloakProvider
      authClient={keycloakInstance}
      onTokens={tokenLogger}
      onEvent={refreshError}
      initOptions={{
        onLoad: 'check-sso',
        checkLoginIframe: false,
        pkceMethod: 'S256',
      }}
    >
      <React.StrictMode>
        <AppRouter />
      </React.StrictMode>
    </ReactKeycloakProvider>
  );
};

export default App;
